var _circle, _path, _circle2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateSunLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.834v1.667M14 21.5v1.667M7.517 7.517 8.7 8.7M19.3 19.3l1.183 1.183M4.833 14H6.5M21.5 14h1.667M7.517 20.483 8.7 19.3M19.3 8.7l1.183-1.183",
    stroke: "#C9A87A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.535,
    cy: 14,
    fill: "#C9A87A",
    fillOpacity: 0.16,
    r: 3.571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.167a4.167 4.167 0 1 0 0-8.333 4.167 4.167 0 0 0 0 8.333z",
    stroke: "url(#iieu1ydr8a)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iieu1ydr8a",
    x1: 15.856,
    y1: 12.895,
    x2: 11.28,
    y2: 13.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateSunLight);
export default __webpack_public_path__ + "static/media/corporateSunLight.f640ee20251d950faebe690a67c07438.svg";
export { ForwardRef as ReactComponent };